define([
    "./trackingLGPDModule",
], function (trackingLGPDModule) {
    "use strict";

    trackingLGPDModule.config(["lgpdApiByArtifactProvider", function (lgpdApiByArtifact) {
        lgpdApiByArtifact.addArtifactApi("tracking", "trackingLgpdApi");
    }]);
});